var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.havePermission)?_c('div',[_c('FileManager',{attrs:{"inline":"","type":_vm.type}}),_c('ImageFilter')],1):_c('h3',{staticClass:"tc"},[_vm._v("You don't have permission")])])}
var staticRenderFns = []

export { render, staticRenderFns }